import React, { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { useHistory } from 'react-router-dom';

import { Menu, MenuItem, IconButton, InputBase, Button } from '@material-ui/core';
import { ExpandMore, Search, Close, Clear } from '@material-ui/icons';

import { unCamelCase } from '../../helpers/camelCase';
import clearUrl from '../../helpers/clearUrl';

const SearchBox = ({ selectItems, onSubmitSearch, setIsOrdering = () => {} }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchBox, setSearchBox] = useState({ searchItem: 'id', search: '' });
  const [selectedItem, setSelectedItem] = useState(null);
  const [isSearching, setIsSearching] = useState(false);

  useEffect(() => {
    if (Array.isArray(selectItems)) {
      setSelectedItem(selectItems[0]);
      setSearchBox({ searchItem: selectItems[0], search: '' });
    }
  }, [selectItems]);

  const handleMenuOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuSelect = item => {
    setSearchBox({ ...searchBox, searchItem: item });
    setSelectedItem(item);
    setAnchorEl(null);
  };

  const closeSearch = () => {
    setSearchBox({ searchItem: selectItems[0], search: '' });
    onSubmitSearch(false);
    setIsSearching(false);
    setIsOrdering(0);
    changeUrl(false);
  };

  const searchOnEnter = event => {
    setIsSearching(true);
    setSearchBox({ ...searchBox, search: event.target.value });
    onSubmitSearch(searchBox);
    changeUrl(true);
  };

  const handleKeyPress = event => {
    switch (event.key) {
      case 'Enter':
        searchOnEnter(event);
        break;
      case 'Escape':
        closeSearch();
        break;
      default:
        return null;
    }
  };

  const handleSearchClick = event => {
    if (!isSearching) {
      searchOnEnter(event);
      changeUrl(true);
    } else {
      closeSearch();
    }
  };

  const changeUrl = isSearching => {
    if (searchBox.searchItem && searchBox.search && isSearching) {
      history.push('/' + clearUrl());
      window.history.pushState(
        { searching: true },
        'Searching',
        window.location.href + '/searchItem=' + searchBox.searchItem + '&search=' + searchBox.search
      );
    } else {
      history.push('/' + clearUrl());
      setIsSearching(false);
    }
  };

  return (
    <>
      <div className="search-clear-filter">
        <Button data-testid="buttonClear" onClick={() => closeSearch()} variant="contained" className="search-clear-btn" color="primary">
          Clear
          <Clear />
        </Button>
      </div>
      <div className="search-container">
        <div className="select-menu">
          <IconButton data-testid="select-menu" aria-controls="simple-menu" aria-haspopup="true" onClick={handleMenuOpen}>
            {selectedItem && unCamelCase(selectedItem)} <ExpandMore></ExpandMore>
          </IconButton>
          <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleMenuClose}>
            {selectItems.map(item => (
              <MenuItem data-testid={item} key={item} onClick={() => handleMenuSelect(item)}>
                {unCamelCase(item)}
              </MenuItem>
            ))}
          </Menu>
        </div>
        <div className="search-input">
          <InputBase
            placeholder="Search..."
            inputProps={{ 'aria-label': 'search' }}
            value={searchBox.search}
            onChange={e => setSearchBox({ ...searchBox, search: e.target.value }, setIsSearching(true))}
            onKeyDown={event => handleKeyPress(event)}
            data-testid="search-input"
          />
          <div className="search-icon">
            <IconButton onClick={event => handleSearchClick(event)}>{!isSearching ? <Search /> : <Close />}</IconButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchBox;
